/** source: https://en.wikipedia.org/wiki/DTMF#Keypad */
const frequenciesByDigit: Partial<Record<string, [number, number]>> = /* oxfmt-ignore */ {
    "1": [697, 1209], "2": [697, 1336], "3": [697, 1477], "A": [697, 1633],
    "4": [770, 1209], "5": [770, 1336], "6": [770, 1477], "B": [770, 1633],
    "7": [852, 1209], "8": [852, 1336], "9": [852, 1477], "C": [852, 1633],
    "*": [941, 1209], "0": [941, 1336], "#": [941, 1477], "D": [941, 1633],
};

export async function playDigit(digit: string, { signal = AbortSignal.timeout(200) } = {}) {
    const frequencies = frequenciesByDigit[digit];
    if (!frequencies) throw new Error(`invalid digit: ${digit}`);

    // AudioContext, Gain, & Oscillator usage inspired by https://onlinetonegenerator.com/js/DTMFgenerator.js
    const context = new AudioContext();

    const gain = context.createGain();
    gain.connect(context.destination);
    gain.gain.value = 0.1;

    const oscillators = frequencies.map((frequency) => {
        const oscillator = context.createOscillator();
        oscillator.frequency.value = frequency;
        oscillator.connect(gain);
        return oscillator;
    });

    for (const oscillator of oscillators) oscillator.start();
    await new Promise((resolve) => {
        signal.onabort = resolve;
    });
    for (const oscillator of oscillators) oscillator.stop();

    await context.close();
}

export async function playDigits(digits: string) {
    for (const digit of digits) await playDigit(digit);
}
